<template>
  <div>
    <div class="mb-4">
      <topbar
        :titulo="$t('ACADEMICO_MATRICULAS.MATRICULA')"
        :breadcrumbs="breadcrumbs"
      >
        <template #header>
          <b-button
            variant="secondary"
            v-b-tooltip.hover
            :title="$t('GERAL.BTN_VOLTAR_EXPLICACAO')"
            @click="irPara()"
          >
            {{ $t('GERAL.VOLTAR') }}
          </b-button>
        </template>
      </topbar>
      <b-tabs content-class="mt-5">
        <!-- Dados gerais do aluno -->
        <b-tab :title="$t('ACADEMICO_MATRICULAS.DADOS_ALUNO')" active>
          <visualizar-dados-aluno
            :matricula="matricula"
            :aluno="aluno"
            :foto="foto"
          />
        </b-tab>

        <!-- Endereços -->
        <b-tab :title="$t('ACADEMICO_MATRICULAS.DADOS_ENDERECO')">
          <visualizar-enderecos :aluno="aluno" />
        </b-tab>

        <!-- Contatos -->
        <b-tab :title="$t('ACADEMICO_MATRICULAS.DADOS_CONTATO')">
          <visualizar-contatos :aluno="aluno" />
        </b-tab>

        <!-- Contratos -->
        <b-tab :title="$t('ACADEMICO_MATRICULAS.CONTRATOS')">
          <visualizar-contratos
            :matriculaId="matricula.id"
            v-if="matricula.id"
          />
        </b-tab>

        <!-- Responsaveis -->
        <b-tab :title="$t('ACADEMICO_MATRICULAS.DADOS_RESPONSAVEIS')">
          <visualizar-responsaveis :vinculos="matricula.vinculos" />
        </b-tab>

        <b-tab :title="$t('FICHA_SAUDE.FICHA_SAUDE')">
          <visualizar-ficha-saude
            :matriculaId="matricula.id"
            v-if="matricula.id"
          />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';

// Services:
import MatriculaService from '@/common/services/matriculas/matriculas.service';
import PessoaService from '@/common/services/pessoa/pessoa.service';

// Components:

import VisualizarDadosAluno from '@/views/academico/matriculas/components/VisualizarDadosAluno.vue';
import VisualizarEnderecos from '@/views/academico/matriculas/components/VisualizarEnderecos.vue';
import VisualizarContatos from '@/views/academico/matriculas/components/VisualizarContatos.vue';
import VisualizarContratos from '@/views/academico/matriculas/components/VisualizarContratos.vue';
import VisualizarResponsaveis from '@/views/academico/matriculas/components/VisualizarResponsaveis.vue';
import VisualizarFichaSaude from '@/views/academico/matriculas/components/VisualizarFichaSaude.vue';

export default {
  components: {
    Topbar,
    VisualizarDadosAluno,
    VisualizarEnderecos,
    VisualizarContatos,
    VisualizarContratos,
    VisualizarResponsaveis,
    VisualizarFichaSaude,
  },
  data() {
    return {
      matriculaId: this.$route.params.id,
      matricula: {},
      foto: null,
      aluno: {},
      breadcrumbs: [
        { titulo: this.$t('ACADEMICO_MATRICULAS.ACADEMICO') },
        { titulo: this.$t('ACADEMICO_MATRICULAS.MATRICULA') },
        { titulo: this.$t('GERAL.VISUALIZAR') },
      ],
    };
  },
  mounted() {
    if (this.matriculaId) {
      this.buscarPorId();
    }
  },
  methods: {
    buscarFoto() {
      if (this.$route.params.id !== undefined) {
        this.$store.dispatch(START_LOADING);
        PessoaService.getFoto(this.matricula.pessoaId)
          .then(({ data }) => {
            this.foto = data.documento
              ? 'data:image/jpeg;base64,' + data.documento
              : null;
          })
          .catch(() => {
            // mensagem.showErrors(err);
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      }
    },
    buscarPorId() {
      this.$store.dispatch(START_LOADING);
      MatriculaService.buscarPorId(this.matriculaId)
        .then(({ data }) => {
          this.matricula = data;
          this.buscarFoto();
          this.buscarAluno(this.matricula.pessoaId);
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    buscarAluno(id) {
      this.$store.dispatch(START_LOADING);
      PessoaService.buscarPorId(id)
        .then(({ data }) => {
          this.aluno = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    irPara() {
      this.$router.push({ name: 'matriculas' });
    },
  },
};
</script>
